import { Schema, defineTable } from 'squid';
export const jobTable = defineTable('job', {
    carrier: Schema.nullable(Schema.String),
    closed_reason: Schema.nullable(Schema.String),
    description: Schema.nullable(Schema.String),
    id: Schema.String,
    is_closed: Schema.Boolean,
    latest_timeline_event: Schema.String,
    latest_work_auth_status: Schema.nullable(Schema.String),
    number: Schema.Number,
    related_claim_number: Schema.nullable(Schema.String),
    status: Schema.nullable(Schema.String),
    type: Schema.String,
    bill_paid_date: Schema.nullable(Schema.String),
    bill_is_paid: Schema.nullable(Schema.Boolean),
    invoice_paid_date: Schema.nullable(Schema.String),
    invoice_is_paid: Schema.nullable(Schema.Boolean),
});
